import __operaRegexp from './__opera-regexp';
import { matchVersion } from '../../utils';
/** Detect Opera Browser version */
export default function isOperaVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __operaRegexp,
			groupIndex: 1
		});
	};
}
